import VehicleTileSkeleton from './vehicle-tile-skeleton';

export default function VehicleTileSkeletonGrid() {
  return (
    <div className="vehicle-tiles-grid vehicle-tiles-grid-side-filter h-fit">
      {Array.from({ length: 9 }).map((_, i) => (
        <VehicleTileSkeleton key={i} />
      ))}
    </div>
  );
}
